$('.slider-for').slick({
    arrows: false,
    asNavFor: '.slider-nav',
});
$('.slider-nav').slick({
    asNavFor: '.slider-for',
    slidesToShow: 5,
    prevArrow: $('.sliderbutton.__prev'),
    nextArrow: $('.sliderbutton.__next')
});

$('.slider-nav .slidernav-image').on('click', function () {
    var slideIndex = $(this).parents('.slick-slide').data('slick-index');
    $(this).parents('.slider').find('.slider-for').slick('slickGoTo', parseInt(slideIndex), false);
});